import Button from '@ingka/button';
import arrowLeft from '@ingka/ssr-icon/paths/arrow-left';

const NotFound = () => {
  return (

      <div style={{ margin: "auto", width: "80%", paddingTop: "30px" }}>
        <h2 style={{ paddingBottom: "15px" }}>
          We're sorry, the page you are looking for does not exist.
        </h2>
        <Button
          href="/report"
          text="Click here to go back to the main page."
          type="primary"
          fluid
          iconOnly={false}
          ssrIcon={arrowLeft}
        />
      </div>

  );
};

export default NotFound;
